(function(){
    console.log('in..')
    function getPreview(printjob){
        var Preview_URL = 'https://api.tante-e.com/R2D/personalize-preview/';

        fetch(Preview_URL+printjob)
        .then(res => res.json())
        .then(function (response) {
            if(response.stat == 1){
                if(response.image){
                    document.querySelector('.product-image-main img').setAttribute('srcset', response.image);
                    document.querySelector('.product__thumb-item[data-index="0"] img')?.setAttribute('srcset', response.image);
                    document.querySelector('.product-image-main img')?.setAttribute('data-photoswipe-src', response.image);

                    var dumpInput = document.createElement('input');
                    dumpInput.setAttribute('type', 'hidden');
                    dumpInput.setAttribute('name',"properties[_preview_image]");
                    dumpInput.setAttribute('value', response.image);
                    document.querySelectorAll('.product-single__form').forEach(function(form){
                        form.appendChild(dumpInput.cloneNode());
                    });
                    var dumpInput2 = document.createElement('input');
                    dumpInput2.setAttribute('type', 'hidden');
                    dumpInput2.setAttribute('name',"properties[_printjob]");
                    dumpInput2.setAttribute('value', printjob);
                    document.querySelectorAll('.product-single__form').forEach(function(form){
                        form.appendChild(dumpInput2.cloneNode());
                    });
                }
            }
        })
    }

    function findGetParameter(parameterName) {
        var result = null,
            tmp = [];
        location.search
            .substr(1)
            .split("&")
            .forEach(function (item) {
              tmp = item.split("=");
              if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
        return result;
    }

    if(findGetParameter('printjob') != null){
        getPreview(findGetParameter('printjob'));
    }
})();